var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginForm',{attrs:{"is-loading":_vm.isLoginControlLoading,"login-error":_vm.loginError,"server-error":_vm.serverError},on:{"login":_vm.login}})
}
var staticRenderFns = []

export { render, staticRenderFns }